import './common/base';
import Slider from './common/hammer-slider'
import LazySlider from './common/hammer-lazy-slider'
import {
    lazyLoadInstance,
    getScope,
    resizeOrientationAware, http
} from './common/common';
import LazyLoad from "vanilla-lazyload";

let isRegularCustomer = getScope("is_regular_customer");

cr$.ready(function () {

    let lazyProducts = new LazyLoad({
        elements_selector: "#recommendation",
        callback_enter: function (el) {
            http.get('/recommendation.php', {
                params: {
                    scenario: 'home',
                    rotationRate: 0,
                    count: 4,
                    minRelevance: 'medium',
                    list: 'Recomendações home',
                    displayPrice: true,
                    hiddenInvoices: true,
                    displayPercent: false
                }
            }).then(response => {
                cr$.byEl(el).html(response.data);

                const recommendationsEl = cr$.byId('recommendations-list');
                if (recommendationsEl.exists()) {
                    recommendationsEl.addClass('slider-disabled-test');
                    recommendationsEl.removeClass('slider');
                }
                // Destroy remaining instance
                lazyProducts.destroy();
                lazyLoadInstance.update();
            });
        }
    });

    cr$.queryAll('.product-list-item a').click(function () {
        const elm = cr$.byEl(this);
        window.dataLayer.push({
            'event': 'productClick',
            'ecommerce': {
                'click': {
                    'actionField': {'list': elm.attr('data-list')},
                    'products': [{
                        'name': elm.attr('data-name'),
                        'id': elm.attr('data-id'),
                        'price': elm.attr('data-price'),
                        'brand': 'Chico Rei',
                        'category': elm.attr('data-category'),
                        'variant': '',
                        'position': elm.attr('data-position')
                    }]
                }
            }
        });
    });

    if (!isRegularCustomer) {
        http.get(window.location.protocol + "//" + window.location.host + "/phpexe/_get_products_home_wholesalers.php", {
            params: {
                type: 'wholesalerSales'
            }
        }).then(response => {
            if (!response.data) return;

            cr$.byId('products-wholesalers-sales').html(response.data);
        });

        http.get(window.location.protocol + "//" + window.location.host + "/phpexe/_get_products_home_wholesalers.php", {
            params: {
                type: 'wholesaler'
            }
        }).then(response => {
            if (!response.data) return;

            cr$.byId('products-wholesalers').html(response.data);
        });


        let device;

        const slidersToInitPrefix = isRegularCustomer ?  'home-featured': 'home-featured-wholesaler';
        const slidersToRemovePrefix = isRegularCustomer ? 'home-featured-wholesaler' : 'home-featured';

        const mobileSlider = new Slider('#' + slidersToInitPrefix + '-mobile');
        const desktopSlider = new Slider('#' + slidersToInitPrefix + '-desktop');

        cr$.byId(slidersToRemovePrefix + '-desktop').remove();
        cr$.byId(slidersToRemovePrefix + '-mobile').remove();

        resizeOrientationAware(function () {
            device = window.innerWidth > 500 ? 'desktop' : 'mobile';

            if (device === 'desktop') {
                cr$.byId(slidersToInitPrefix + '-mobile').addClass('hidden');
                cr$.byId(slidersToInitPrefix + '-desktop').removeClass('hidden');

                if (mobileSlider) mobileSlider.disable();

                if (desktopSlider.isReady()) {
                    desktopSlider.enable();
                    desktopSlider.forceResize();
                } else {
                    desktopSlider.init({
                        loop: true,
                        adaptOnResize: true,
                        enableBullets: true,
                        autoplayInterval: 6000,
                        fitSlidesToParent: true,
                        onNavigate: () => lazyLoadInstance.update()
                    }, () => lazyLoadInstance.update());
                }
            } else {
                cr$.byId(slidersToInitPrefix + '-desktop').addClass('hidden');
                cr$.byId(slidersToInitPrefix + '-mobile').removeClass('hidden');

                if (desktopSlider) desktopSlider.disable();

                if (mobileSlider && mobileSlider.isReady()) {
                    mobileSlider.enable();
                    mobileSlider.forceResize();
                } else {
                    mobileSlider.init({
                        loop: true,
                        adaptOnResize: true,
                        enableBullets: true,
                        autoplayInterval: 6000,
                        fitSlidesToParent: true,
                        onNavigate: () => lazyLoadInstance.update()
                    }, () => lazyLoadInstance.update());
                }
            }

        }, true);
    }

    requestIdleCallback(() => {
        const parceriasSlider = new Slider('#home-parcerias-slider');

        parceriasSlider.init({
            fitSlidesToParent: true,
            loop: true,
            slidesPerView: 1,
            adaptOnResize: true,
            enableArrows: true,
            enableBullets: false,
            onNavigate: () => lazyLoadInstance.update(),
            responsive: [
                {
                    minWidth: 1250,
                    settings: {
                        slidesPerView: 5
                    }
                },
                {
                    minWidth: 992,
                    settings: {
                        slidesPerView: 4
                    }
                },
                {
                    minWidth: 768,
                    settings: {
                        slidesPerView: 3
                    }
                },
                {
                    minWidth: 576,
                    settings: {
                        slidesPerView: 2
                    }
                }]
        }, () => lazyLoadInstance.update());
    });

    requestIdleCallback(() => {
        const productTypesSlider = new Slider('#home-product-types-slider');

        productTypesSlider.init({
            slidesPerView: 1,
            fitSlidesToParent: true,
            enableBullets: true,
            onNavigate: () => lazyLoadInstance.update(),
            responsive: [
                {
                    minWidth: 576,
                    settings: {
                        slidesPerView: 2,
                    }
                },
                {
                    minWidth: 768,
                    settings: {
                        slidesPerView: 3,
                    }
                },
                {
                    minWidth: 992,
                    settings: {
                        slidesPerView: 4,
                    }
                }
            ]
        }, () => lazyLoadInstance.update());
    });

    requestIdleCallback(() => {
        const instagramSlider = new LazySlider('#instagram-slider');

        instagramSlider.init({
            enableBullets: true,
            fitSlidesToParent: true,
        });
    });
});